import { render, staticRenderFns } from "./StepProgramDocuments.vue?vue&type=template&id=5dce9a70&"
import script from "./StepProgramDocuments.vue?vue&type=script&lang=js&"
export * from "./StepProgramDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StepProgramDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFileInput,VIcon,VProgressCircular,VRow})
